var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.global.selectedAppTab == 5)?_c('div',[_c('nas-card',{attrs:{"clientPortal":_vm.clientPortal,"fixedHeaders":false}}),_c('attribute-card',{attrs:{"clientPortal":_vm.clientPortal}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }